var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#F34242"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  shapeRendering: "crispEdges"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M8 10L8 8L10 8L10 10L8 10Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 12L8 10L10 10L10 12L8 12Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 14L8 12L10 12L10 14L8 14Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M8 16L8 14L10 14L10 16L8 16Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M14 10L14 8L16 8L16 10L14 10Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 12L14 10L16 10L16 12L14 12Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 14L14 12L16 12L16 14L14 14Z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M14 16L14 14L16 14L16 16L14 16Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 16H10V14H12V16Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 16H12V14H14V16Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10H10V8H12V10Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 10H12V8H14V10Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 4V6H12V4H10Z",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 18V16H14V18H12Z",
  fillOpacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 12L16 12L16 14L18 14L18 12Z",
  fillOpacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 12L8 12L8 14L6 14L6 12Z",
  fillOpacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 6V8H14V6H12Z",
  fillOpacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4V6H14V4H12Z",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 20V18H12V20H10Z",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 20V18H14V20H12Z",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 10L18 10L18 12L20 12L20 10Z",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 12L18 12L18 14L20 14L20 12Z",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 12L6 12L6 14L4 14L4 12Z",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 10L6 10L6 12L4 12L4 10Z",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 6V8H12V6H10Z",
  fillOpacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 18V16H12V18H10Z",
  fillOpacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 10L16 10L16 12L18 12L18 10Z",
  fillOpacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 10L8 10L8 12L6 12L6 10Z",
  fillOpacity: 0.75
}));
function SvgRedstoneLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedstoneLogo);
export default __webpack_public_path__ + "static/media/redstone-logo.4de209c175ed4de107142d699110ed41.svg";
export { ForwardRef as ReactComponent };